import { tokens } from "../tokens";
export function useCurrentUser() {
    const { token, initialisationToken } = tokens.get();
    function decodeJWT(token) {
        const [, base64Url] = (token || "").split(".");
        if (!base64Url) {
            return;
        }
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(atob(base64)
            .split("")
            .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
            .join(""));
        return JSON.parse(jsonPayload);
    }
    return decodeJWT(token || initialisationToken);
}
